import { Organisation } from '@prisma/client';

export const importFailed = (
  organisation: Pick<Organisation, 'name' | 'registrationNumber' | 'companiesHouseDataLastStatus'>,
) =>
  !!organisation.registrationNumber &&
  !organisation.name &&
  !!organisation.companiesHouseDataLastStatus &&
  organisation.companiesHouseDataLastStatus !== 200;
